import { websiteConfig } from '@/config/website';
import { getCreditPackages } from '@/config/pricing-config';
import type { CreditPackage } from '@/payment/types';

export function getAllCreditPackages(): CreditPackage[] {
  return getCreditPackages().map((pkg) => {
    const configured = websiteConfig.credits?.packages[pkg.id];
    return configured ? { ...pkg, price: configured.price } : pkg;
  });
}

export function getCreditPackageById(id: string): CreditPackage | undefined {
  return getAllCreditPackages().find((pkg) => pkg.id === id);
}
